import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

import LandingPage from '@/pages/customer/Landing';
import MenuPage from '@/pages/customer/Menu';
import BuilderPage from '@/pages/customer/Builder';
import CartPage from '@/pages/customer/Cart';
import CheckoutPage from '@/pages/customer/Checkout';
import TrackingPage from '@/pages/customer/Tracking';
import LoginPage from '@/pages/customer/Login';
import RegisterPage from '@/pages/customer/Register';
import MyOrdersPage from '@/pages/customer/MyOrders';
import ProfilePage from '@/pages/customer/Profile';

import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminOrders from '@/pages/admin/AdminOrders';
import AdminMenu from '@/pages/admin/AdminMenu';
import AdminZones from '@/pages/admin/AdminZones';
import AdminRiders from '@/pages/admin/AdminRiders';
import AdminLiveMap from '@/pages/admin/AdminLiveMap';
import AdminSettings from '@/pages/admin/AdminSettings';
import AdminDiscountCodes from '@/pages/admin/AdminDiscountCodes';
import AdminCombos from '@/pages/admin/AdminCombos';

import RiderHome from '@/pages/rider/RiderHome';
import RiderHistory from '@/pages/rider/RiderHistory';

import { RequireRole } from '@/components/RequireRole';
import InstallPWAPrompt from '@/components/InstallPWAPrompt';
import { InstallAppDialog } from '@/components/InstallAppDialog';

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        offset={16}
        mobileOffset={{ top: 'calc(env(safe-area-inset-top) + 12px)' }}
      />
      <InstallPWAPrompt />
      <InstallAppDialog />
      <Routes>
        {/* Public / Customer */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/builder" element={<BuilderPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/tracking/:orderId" element={<TrackingPage />} />
        <Route path="/login" element={<LoginPage role="customer" redirect="/" title="Accedi" />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/my-orders" element={<RequireRole roles={['customer']}><MyOrdersPage /></RequireRole>} />
        <Route path="/profile" element={<RequireRole roles={['customer']}><ProfilePage /></RequireRole>} />

        {/* Admin */}
        <Route path="/admin/login" element={<LoginPage role="admin" redirect="/admin" title="Login Admin" />} />
        <Route path="/admin" element={<RequireRole roles={['admin']} loginPath="/admin/login"><AdminDashboard /></RequireRole>} />
        <Route path="/admin/orders" element={<RequireRole roles={['admin']} loginPath="/admin/login"><AdminOrders /></RequireRole>} />
        <Route path="/admin/menu" element={<RequireRole roles={['admin']} loginPath="/admin/login"><AdminMenu /></RequireRole>} />
        <Route path="/admin/zones" element={<RequireRole roles={['admin']} loginPath="/admin/login"><AdminZones /></RequireRole>} />
        <Route path="/admin/riders" element={<RequireRole roles={['admin']} loginPath="/admin/login"><AdminRiders /></RequireRole>} />
        <Route path="/admin/live-map" element={<RequireRole roles={['admin']} loginPath="/admin/login"><AdminLiveMap /></RequireRole>} />
        <Route path="/admin/settings" element={<RequireRole roles={['admin']} loginPath="/admin/login"><AdminSettings /></RequireRole>} />
        <Route path="/admin/discount-codes" element={<RequireRole roles={['admin']} loginPath="/admin/login"><AdminDiscountCodes /></RequireRole>} />
        <Route path="/admin/combos" element={<RequireRole roles={['admin']} loginPath="/admin/login"><AdminCombos /></RequireRole>} />

        {/* Rider */}
        <Route path="/rider/login" element={<LoginPage role="rider" redirect="/rider" title="Login Rider" />} />
        <Route path="/rider" element={<RequireRole roles={['rider']} loginPath="/rider/login"><RiderHome /></RequireRole>} />
        <Route path="/rider/history" element={<RequireRole roles={['rider']} loginPath="/rider/login"><RiderHistory /></RequireRole>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
